// extracted by mini-css-extract-plugin
export var childrenContainer = "_7x-0";
export var virtualScrollArea = "_7x-1";